import axios from "axios";
const config = require("../config");

class GolfCourse {
    constructor(properties) {
        this.name = "";
        this.par = 0;
        this.holes = 0;
        this.yardage = 0;
        this.description = "";
        this.acceptsCredit = false;
        this.contracts = [];
        this.pricingMatrix = this.buildEmptyPricingMatrix();

        Object.assign(this, properties);
    }
    buildEmptyPricingMatrix() {
        const matrix = {};

        for (let month = 1; month <= 12; month++) {
            matrix[month] = {
                poa: false,
                highest: null,
                lowest: {
                    country: null,
                    links: null,
                    club: null,
                },
            };

            for (let day = 1; day <= 7; day++) {
                matrix[month][day] = {};

                for (let hour = 0; hour <= 23; hour++) {
                    matrix[month][day][hour] = {
                        country: { price: null, creditBookable: false },
                        links: { price: null, creditBookable: false },
                        club: { price: null, creditBookable: false },
                    };
                }
            }
        }

        return matrix;
    }
    static getById(id) {
        return axios.get(config.api_url + "clubs/" + id);
    }

    store(clubId) {
        return axios.post(config.api_url + "clubs/" + clubId + "/courses", {
            name: this.name,
            holes: this.holes,
            par: this.par,
            yardage: this.yardage,
            description: this.description,

            pricingMatrix: this.pricingMatrix,

            acceptsCredit: this.acceptsCredit,
            GFCVisibility: this.GFCVisibility,
            ...(this.group?._id ? { group: this.group._id } : {}),
        });
    }

    update() {
        return axios.put(
            config.api_url + "clubs/" + this.club._id + "/courses/" + this._id,
            {
                name: this.name,
                holes: this.holes,
                par: this.par,
                yardage: this.yardage,
                description: this.description,

                pricingMatrix: this.pricingMatrix,

                acceptsCredit: this.acceptsCredit,
                GFCVisibility: this.GFCVisibility,
                ...(this.group?._id ? { group: this.group._id } : {}),
            },
        );
    }

    delete() {
        return axios.delete(
            config.api_url + "clubs/" + this.club._id + "/courses/" + this._id,
        );
    }

    static async list(params = {}) {
        const { data } = await axios.get(config.api_url + "courses/list", {
            params,
        });
        return data.data.map((item) => new GolfCourse(item));
    }

    static async availability(courseId, month, year, member, voucher) {
        const { data } = await axios.get(
            `${config.api_url}courses/${courseId}/availability`,
            {
                params: {
                    month,
                    year,
                    member,
                    voucher,
                },
            },
        );
        return data.data;
    }

    static async creditAvailability(
        courseId,
        month,
        year,
        member,
        voucher = null,
        booking = null,
    ) {
        const { data } = await axios.get(
            `${config.api_url}courses/${courseId}/credit-availability`,
            {
                params: {
                    month,
                    year,
                    member,
                    booking,
                    voucher,
                },
            },
        );
        return data.data;
    }

    static async creditPrice(courseId, member) {
        const { data } = await axios.get(
            `${config.api_url}courses/${courseId}/credit-price`,
            {
                params: {
                    member,
                },
            },
        );
        return data.data;
    }

    static async quote(
        courseId,
        day,
        month,
        year,
        hour,
        players,
        member,
        voucher = null,
        booking = null,
    ) {
        const { data } = await axios.get(
            `${config.api_url}courses/${courseId}/quote`,
            {
                params: {
                    day,
                    month,
                    year,
                    hour,
                    players,
                    member,
                    voucher,
                    booking,
                },
            },
        );
        return data.data;
    }

    static async creditQuote(
        courseId,
        day,
        month,
        year,
        hour,
        players,
        member,
        voucher = null,
        booking = null,
    ) {
        const { data } = await axios.get(
            `${config.api_url}courses/${courseId}/credit-quote`,
            {
                params: {
                    day,
                    month,
                    year,
                    hour,
                    players,
                    member,
                    voucher,
                    booking,
                },
            },
        );
        return data.data;
    }

    static async creditPrice(courseId, member) {
        const { data } = await axios.get(
            `${config.api_url}courses/${courseId}/credit-price`,
            {
                params: {
                    member,
                },
            },
        );
        return data.data;
    }
}

export default GolfCourse;
